module.exports = __webpack_public_path__ + "img/translate-four.fff1c8bd.png";